import React, { useCallback, useContext, useMemo } from 'react'
import PageBanner from 'LuxKit/Banners/PageBanner'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import GeoContext from 'contexts/geoContext'
import { END_SPEND_EARN_PROMO_TAG_DATE, PROMO_SPEND_EARN_REGION } from 'constants/tours'
import ModalContext from 'contexts/ModalContext'
import TourSpendEarnDetailModal from 'components/Tours/TourSpendEarnDetailModal'
import { useScreenSizeBetween } from 'hooks/useScreenSize'
import TextLink from 'LuxKit/TextLink'
import styled from 'styled-components'
import { rem } from 'polished'

const LearnMoreButton = styled(TextLink)`
  margin-left: ${rem(8)};
`

function TourSpendEarnPageBanner() {
  const { currentRegionCode, currentCurrency } = useContext(GeoContext)
  const showModal = useContext(ModalContext)
  const creditEarnListRegion = PROMO_SPEND_EARN_REGION[currentRegionCode]
  const isBetweenTabletToDesktopSize = useScreenSizeBetween('tablet', 'extraLargeDesktop')

  const bestCreditEarn = useMemo<number>(() => {
    const creditEarnList = creditEarnListRegion ?? []
    if (creditEarnList.length) {
      return Math.max(...creditEarnList.map(creditEarn => creditEarn.earn))
    }
    return 0
  }, [creditEarnListRegion])

  const showSpendEarnDetail = useCallback(() => {
    showModal(<TourSpendEarnDetailModal spendEarnList={creditEarnListRegion} maxCredit={bestCreditEarn} />)
  }, [bestCreditEarn, creditEarnListRegion, showModal])

  if (new Date() > END_SPEND_EARN_PROMO_TAG_DATE) {
    return null
  }

  return <PageBanner
    kind="promotional-primary-accent"
    align="start"
    tabletAlign="center"
    description={<>
      <b>Spend More, Earn More!</b> Enjoy up to <FormatCurrency value={bestCreditEarn} currency={currentCurrency} /> Luxury Escapes credit{isBetweenTabletToDesktopSize ? ' for your next booking' : ''}. Use code: <b>TOURDEAL</b><LearnMoreButton onClick={showSpendEarnDetail}>Learn more</LearnMoreButton>
    </>}
  />
}

export default TourSpendEarnPageBanner
